import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const Button = styled.span`
  display: flex;
  align-items: center;
  text-decoration: underline;
  cursor: pointer;
  ${({ margin }) => (margin ? `margin: ${margin};` : '')}
`;

export default function ExportCSV({
  csvData,
  csvDataBuilder,
  fileName,
  buttonLabel,
  margin,
  style,
  Icon,
}) {
  const fileType = useMemo(
    () => 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    []
  );
  const fileExtension = useMemo(() => '.xlsx', []);

  const exportToExcel = useCallback(
    (csvData, fileName) => {
      const ws = XLSX.utils.json_to_sheet(csvData);
      const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    },
    [fileExtension, fileType]
  );

  const doExport = useCallback(async () => {
    const data = csvData || (await csvDataBuilder());
    exportToExcel(data, fileName);
  }, [csvData, csvDataBuilder, exportToExcel, fileName]);

  return (
    <Button margin={margin} style={style} onClick={doExport}>
      {Icon && Icon}
      {buttonLabel}
    </Button>
  );
}
